"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChallengeBase = void 0;
const react_1 = require("react");
const features_1 = require("../../../features");
const useChallengeBase = ({ authoriser, onVerify, onVerifyError }) => {
    const [state, setState] = (0, react_1.useState)(authoriser.state);
    const { isChallengeLoading, isChallengeVerifying, isChallengeVerificationFailed, challengeRetryStatus, ivrChallengeStatus } = state;
    const getVerifiedChallenge = () => authoriser.challenge?.data.type ?? features_1.ChallengeType.NONE;
    (0, react_1.useEffect)(() => {
        if (state.isChallengeVerificationFailed) {
            onVerifyError?.(getVerifiedChallenge(), state.challengeVerificationError);
        }
    }, [state.isChallengeVerificationFailed]);
    (0, react_1.useEffect)(() => {
        if (state.isChallengeVerificationSucceeded) {
            onVerify?.(getVerifiedChallenge());
        }
    }, [state.isChallengeVerificationSucceeded]);
    (0, react_1.useEffect)(() => {
        const onStateChangeUnbSubscribe = authoriser.onStateChange(newState => {
            setState(newState);
        });
        authoriser.subscribeIvrEvents();
        return () => {
            onStateChangeUnbSubscribe();
            authoriser.unsubscribeIvrEvents();
        };
    }, [authoriser]);
    return {
        state,
        isChallengeLoading,
        isChallengeVerifying,
        isChallengeVerificationFailed,
        challengeRetryStatus,
        ivrChallengeStatus,
        challenges: authoriser.getChallengesData(),
        currentChallenge: authoriser.challenge?.data.type || features_1.ChallengeType.NONE,
        pastChallenges: authoriser.pastChallenges,
        otpChallengeChannel: authoriser.challenge?.data?.channel,
        skChallengePositions: authoriser.challenge?.data?.signatureKeyPositions,
        transferToChallengeIvr: () => authoriser.transferToChallengeIvr(),
        handleChallengeVerify: (value) => authoriser.verifyChallenge(value),
        handleChallengeRetry: () => authoriser.retryChallenge(),
    };
};
exports.useChallengeBase = useChallengeBase;
exports.default = exports.useChallengeBase;
//# sourceMappingURL=useChallengeBase.hook.js.map